import Button from "@components/Button/Button";
import IconImg from "@components/Icon/IconImg";
import { IconTypeEnum } from "@components/Icon/types";
import { GiftAnArticleButtonProps } from "@features/giftAnArticle/utils/types";
import { cn } from "@util/helpers";

export default function GiftAnArticleButtonVersion2({
  handleClick,
  className,
}: GiftAnArticleButtonProps): React.ReactElement {
  return (
    <Button
      onClick={handleClick}
      testId="action-button-subshare"
      className={cn("aspect-square", className)}
    >
      <IconImg icon={IconTypeEnum.gift} iconSize={24} imgAlt={"share button"} />
    </Button>
  );
}
